import GameiomModel from "gameiom/model/gameiom-model";
import { UiElements } from "gameiom/wrapper/wrapper-data";
import AbstractButtonControl from "slotworks/smart-ui/controls/abstract/abstract-button-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";

export default class AgsDepositButtonControl extends AbstractButtonControl implements Control {

    public updateOptions(options: ControlOptions) {
        this.setVisible(GameiomModel.displayButtons.get(UiElements.depositPageButton));
        super.updateOptions(options);
    }

    protected onClick() {
        gameWrapper.gotoDepositPage();
        super.onClick();
    }
}
